import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sidebar-item-container" }
const _hoisted_2 = { class: "sidebar-item-content" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar-item-content__icon-wrapper"
}
const _hoisted_4 = {
  key: 2,
  class: "sidebar-item-badge"
}
const _hoisted_5 = {
  key: 1,
  class: "sidebar-item-content__expand-icon"
}

import SvgLoader from '@/utils/SvgLoader.vue';
import { computed } from 'vue';
import { RouterItem } from './interfaces/routerItems';
import { i18n } from '@/i18n';
import { removeTokenIfExpired } from '@/appLogic/tokenAroundManagement';
import { useRouter } from 'vue-router';
import { displaySessionErrorInfo } from '@/corePagesModule/components/InfoModal/displaySessionErrorInfo';
import Mdi from '@/corePagesModule/components/Mdi.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarExpandedItem',
  props: {
    routeItem: {},
    isRoot: { type: Boolean },
    isOpenChildren: { type: Boolean }
  },
  emits: ["onClickExpansionToggle"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const router = useRouter();

const props = __props;

const emits = __emit;

const computedLinkPath = computed((): string => {
  return props.routeItem.expandChildren && props.isRoot ? '' : props.routeItem.to;
});

const onClickExpandedItem = (): void => {
  if (props.routeItem.expandChildren && props.isRoot) {
    emits('onClickExpansionToggle');
  }
};

const handleClick = async (child?: RouterItem) => {
  if (!child) return;
  // ここでトークンチェック（Storeや関数を呼ぶ）
  const ok = await removeTokenIfExpired();

  if (ok) {
    router.push(child.to); // 正常ならそのまま遷移
  } else {
    // トークンが期限切れの場合はモーダルを表示してログイン画面に遷移させる
    await displaySessionErrorInfo();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      "data-testid": _ctx.routeItem.to == '/translate-excel' ? `sidebar-content_inventory_information` : '',
      to: computedLinkPath.value,
      onClick: [
        onClickExpandedItem,
        _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleClick(_ctx.routeItem)), ["prevent"]))
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isRoot && _ctx.routeItem.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.routeItem.icon.startsWith('sidebar-logo'))
                  ? (_openBlock(), _createBlock(SvgLoader, {
                      key: 0,
                      class: "sidebar-item-content__icon-image",
                      name: _ctx.routeItem.icon
                    }, null, 8, ["name"]))
                  : (_openBlock(), _createBlock(Mdi, {
                      key: 1,
                      class: "sidebar-item-content__icon-image",
                      icon: _ctx.routeItem.icon,
                      tag: "div"
                    }, null, 8, ["icon"])),
                (_ctx.routeItem.badge && _ctx.routeItem.badge !== '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.routeItem.badge), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_i18n_t, {
            class: _normalizeClass(["sidebar-item-content__label-text i18n-break", { 'sidebar-item-content__label-text--child-item': !_ctx.isRoot }]),
            keypath: _ctx.routeItem.longName ? _ctx.routeItem.longName : _ctx.routeItem.name,
            tag: "p"
          }, {
            newLine: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }, 8, ["class", "keypath"]),
          (_ctx.routeItem.expandChildren && _ctx.isRoot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (props.isOpenChildren)
                  ? (_openBlock(), _createBlock(SvgLoader, {
                      key: 0,
                      class: "sidebar-item-content__expand-icon--opened",
                      name: "arrowDown"
                    }))
                  : (_openBlock(), _createBlock(SvgLoader, {
                      key: 1,
                      class: "sidebar-item-content__expand-icon--closed",
                      name: "chevronRight"
                    }))
              ]))
            : _createCommentVNode("", true)
        ])
      ], undefined, true),
      _: 1
    }, 8, ["data-testid", "to"])
  ]))
}
}

})